import { render } from "./scrollPage.vue?vue&type=template&id=44f0c69f"
import script from "./scrollPage.vue?vue&type=script&lang=js"
export * from "./scrollPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__